import { isPlatform } from "@ionic/react";
function disableRightClick() {

    document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
    });
}
function digitalRightsManagement() {
    // Disable Right-Click
    if (!isPlatform('capacitor') && !(isPlatform('mobile') && isPlatform('desktop'))) {
        disableRightClick()
    }
    document.addEventListener('keydown', function (event) {
        // Block F12 key, right-click, and other common DevTools shortcuts
        if (event.key === 'F12' ||
            (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'C')) ||
            (event.ctrlKey && event.key === 'U')) {
            event.preventDefault();
        }
    });
    if (typeof console != "undefined") {
        console.log = function () { };
        console.warn = function () { };
        console.error = function () { };
    }
}
export default digitalRightsManagement